import cyclops from '../../media/img/lab/egg-agents/cyclops.png';
import headExplode from '../../media/img/lab/egg-agents/head-expode.png';
import hooman from '../../media/img/lab/egg-agents/hooman.png';
import melting from '../../media/img/lab/egg-agents/melting.png';
import shocked from '../../media/img/lab/egg-agents/shocked.png';
import sleepy from '../../media/img/lab/egg-agents/sleepy.png';
import sus from '../../media/img/lab/egg-agents/sus.png';
import tongue from '../../media/img/lab/egg-agents/tongue.png';
import wowed from '../../media/img/lab/egg-agents/wowed.png';
import zombie from '../../media/img/lab/egg-agents/zombie.png';
import cursing from '../../media/img/lab/egg-agents/damn.png';


  export const quirkyList = [
    "Toaster with trust issues",
    "Confused platypus",
    "Rubber chicken",
    "Disco ball",
    "Suspicious sandwich",
    "Time-traveling cactus",
    "Sock without a partner",
    "Dramatic seagull",
    "Jar of mysterious buttons",
    "Keyboard that only types emojis",
    "Haunted teapot",
    "Bicycle powered by sarcasm",
    "Grumpy goldfish",
    "Suitcase full of glitter",
    "Parrot that only quotes movies",
    "Prophetic jellybean",
    "Squirrel in a tiny tuxedo",
  ];
  export const imageDictionary = {
    iseeu: cyclops,
    sus: sus,
    yourheadasplode: headExplode,
    noway: shocked,
    hooman: hooman,
    livingdead: zombie,
    damn: cursing,
    zzz: sleepy
  };

